export default "__VITE_ASSET__DpwkIaP9__"